module.exports = __webpack_public_path__ + "static/media/sucesso_exportacao.b7c64cc6.svg";